module.exports = "/images/cloud_a.png";